import DexLeftComponent from '@/components/DexLeftComponent';
import usePage from '@/hooks/use-page';
import { useNavigate } from '@/lib/router-dom';
import { Box } from '@dextech-ai/dex-design-system';

const Page = () => {

	/*=================================================
		General
	/================================================*/

	usePage({ title: 'Forget Password' })

	const { goTo } = useNavigate()

	return (
		<div className='layout-login'>
			<DexLeftComponent />
			<div className="layout-login__right">
				<div className="login-box">
					<div className="forgetPassword-box__title">Reset Link Sent!</div>
					<div className="forgetPassword-box__desc">We sent you a secure link to reset your password. Please check your email.</div>
					<form onSubmit={()=>(goTo('/login'))}>
						<Box mt={10}>
							<button type="submit" className="button--rounded forgetPassword-box__form__action__top" value="Submit">Back to Log In</button>
						</Box>
					</form>
				</div>
			</div>
		</div>
	)
}
export default Page
